import DatahubPage from '@react/data-hub/components/DatahubPage';
import DatahubContextProvider from '@react/data-hub/context/DatahubContextProvider';
import { InsightsFilters } from '@sly/frontend/react/data-hub/types/misc';
import {
  getApiFilters,
  getSearchParams,
} from '@sly/frontend/react/search/helpers';
import { useRouter } from 'next/router';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default function Page() {
  const { query } = useRouter();
  const { toc, city, state, roomType } = query || {};

  return (
    <DatahubContextProvider
      filters={
        {
          toc,
          city,
          state,
          roomType,
          include: 'county,state',
        } as InsightsFilters
      }
    >
      <DatahubPage />
    </DatahubContextProvider>
  );
}

export async function getServerSideProps({
  query,
}: {
  query: { toc: string; city: string; state: string; roomType: string };
}) {
  const { api, store } = createApiClient(apiEndpoints);

  const { toc, city, state, roomType } = query || {};

  const currentFilters = getSearchParams(query);
  const apiFilters = getApiFilters(currentFilters);

  try {
    await Promise.all(
      [
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getSearchInsights.asAction({
          'care-type': toc,
          'filter[state]': state,
          'filter[city]': city,
          'filter[room-type]': roomType,
          include: 'county,state',
        }),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getGeoGuides.asAction({
          city: city,
          state: state,
          toc: toc,
        }),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getSearchPage.asAction({
          include: 'community',
          ...apiFilters,
          'page-size': 6,
        }),
      ].map(store.dispatch)
    );
  } catch (e: unknown) {
    console.error('error', e);
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
